// Where an inbox entry leads (spec §3.7): a path inside the galaxy (`/g/:galaxyId/<path>`), or null
// when the notification has nothing to open. Payload keys: 04-api-design §7.4.
const id = (value: unknown): string | null =>
  typeof value === 'string' && value.length > 0 ? value : null;

const system = (systemId: string | null, tab?: 'shipyard' | 'port'): string | null =>
  systemId ? `systems/${systemId}${tab ? `?tab=${tab}` : ''}` : null;

const battle = (prefix: 'battles' | 'battle-reports', battleId: string | null): string | null =>
  battleId ? `${prefix}/${battleId}` : null;

export function notificationTarget(
  type: string,
  payload: Record<string, unknown>,
  homeSystemId?: string
): string | null {
  switch (type) {
    case 'BUILDING_COMPLETED':
    case 'SYSTEM_OWNER_CHANGED':
    case 'SCOUT_FAILED_AGAINST_YOU':
    case 'CLAIM_PLACED':
    case 'CLAIM_ACTIVATED':
    case 'CLAIM_RESOLVED':
      return system(id(payload.systemId));
    case 'SHIP_PRODUCED':
      return system(id(payload.systemId), 'shipyard');
    case 'PORT_TRADE_COMPLETED':
      return system(id(payload.systemId), 'port');
    case 'SCOUT_RETURNED':
      return system(id(payload.targetSystemId));
    case 'SHIELD_WARNING':
    case 'SHIELD_EXPIRED':
      return system(id(homeSystemId));
    case 'FLEET_INCOMING':
    case 'FLEET_INCOMING_CANCELLED':
    case 'FLEET_ORDER_FAILED':
    case 'FLEET_ORDER_RESCHEDULED':
      return 'fleet';
    case 'BATTLE_STARTED':
      return battle('battles', id(payload.battleId));
    case 'BATTLE_ENDED':
      return battle('battle-reports', id(payload.battleId));
    case 'ALLIANCE_INVITE_RECEIVED': {
      const allianceId = id(payload.allianceId);
      return allianceId ? `alliances/${allianceId}` : 'alliance';
    }
    case 'ALLIANCE_APPLICATION_RECEIVED':
      return 'alliance?tab=recruiting';
    default:
      return type.startsWith('ALLIANCE_') ? 'alliance' : null;
  }
}
